import { render, staticRenderFns } from "./KBKLimitDetails.view.vue?vue&type=template&id=42b1ab60&"
import script from "./KBKLimitDetails.view.vue?vue&type=script&lang=js&"
export * from "./KBKLimitDetails.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42b1ab60')) {
      api.createRecord('42b1ab60', component.options)
    } else {
      api.reload('42b1ab60', component.options)
    }
    module.hot.accept("./KBKLimitDetails.view.vue?vue&type=template&id=42b1ab60&", function () {
      api.rerender('42b1ab60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/kbk-limits/update/KBKLimitDetails.view.vue"
export default component.exports